import { z } from 'zod';
import type React from 'react';

/**
 * --- Schemas ---
 */

const reasonLandRegisterQuerySchema = z.object({
  idRealEstate: z.number(),
  Reason: z.string(),
});

export const PurchaseContractRelationshipDataViewV1 = z.object({
  ThirdPartyClauseText: z.string().optional().nullable(),
  withThirdPartyClause: z.boolean().optional(),
  ReasonLandRegisterQueryArray: z
    .array(reasonLandRegisterQuerySchema)
    .optional(),
});

export type ILegalTransactionRelationshipDataPurchaseContractV1 = z.infer<
  typeof PurchaseContractRelationshipDataViewV1
>;

export const legalTransactionRelationshipDataSignatureCertificationV1 =
  z.object({
    idContractObjectType: z.number(),
    idContactObjectSubtype: z.number(),
    textcontactObjectSubtype: z.string(),
    idCountryTextLanguage: z.number(),
    idCountryUseOfText: z.number(),
    notes: z.string(),
  });

export type ILegalTransactionRelationshipDataSignatureCertificationV1 = z.infer<
  typeof legalTransactionRelationshipDataSignatureCertificationV1
>;

export const legalTransactionRelationshipDataGenericV1 = z.object({
  notes: z.string().optional(),
});

export type ILegalTransactionRelationshipDataGenericV1 = z.infer<
  typeof legalTransactionRelationshipDataGenericV1
>;

export const ILegalTransactionRelationshipCompanyFormationV1 = z.object({
  ShareCapital: z.number(),
  isFounding: z.boolean(),
  PurposeOfTheCompany: z.string(),
  AmountShares: z.number(),
  ValuePerShare: z.number(),
  useSampleProtocol: z.boolean(),
  CommentRepresentativeRegulation: z.string().nullable(),
  CommentRealEstate: z.string().nullable(),
  idCompanyFormationOption: z.number().nullable(),
});

export type ILegalTransactionRelationshipDataCompanyFormationV1 = z.infer<
  typeof ILegalTransactionRelationshipCompanyFormationV1
>;

export type { ViewProps, ViewComponent } from '../GenericViews/IGenericView';
